module.exports = __webpack_public_path__ + "static/media/death.9540f702.png";